const env = process.env.REACT_APP_ENV || "dev";

let apiUrl, partnerApi, socket;
switch (env) {
  case "dev":
    apiUrl = "https://api.dev.insurancesamadhan.com/";
    partnerApi = "https://partnersapi.dev.insurancesamadhan.com/";
    socket = "wss://socketserver.dev.insurancesamadhan.com";
    break;
  case "stage":
    apiUrl = "https://api.stage.insurancesamadhan.com/";
    partnerApi = "https://partnersapi.stage.insurancesamadhan.com/";
    socket = "wss://socketserver.stage.insurancesamadhan.com";
    break;
  case "prod":
    apiUrl = "https://api.insurancesamadhan.com/";
    partnerApi = "https://partnersapi.insurancesamadhan.com/";
    socket = "wss://socketserver.insurancesamadhan.com";
    break;
  default:
    apiUrl = "http://localhost:3999/";
    partnerApi = "https://partnersapi.dev.insurancesamadhan.com/";
    socket = "wss://socketserver.dev.insurancesamadhan.com";
}

export const baseUrl = apiUrl;
export const partnerUrl = partnerApi;
export const socketUrl = socket;
